export default __webpack_public_path__ + "static/media/ff_es.455a136a.png";